import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/main.css";
import authscreens from "../images/auth-screens.png";
import neo from "../images/neo.png";
import logo from '../images/neoHeader.png';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { decrypt, encrypt } from "../utils/cryptoUtils";

const LoginPage = () => {

  localStorage.setItem('is_logged_in', false);
  localStorage.removeItem('user_details');
  localStorage.removeItem('ui_details');

  const [userInput, setUserInput] = useState("");
  const [otp, setOTP] = useState("");
  const [otpSent, setOTPSent] = useState(false);
  const [role, setRole] = useState("");
  const [error, setError] = useState("");
  const [isGeneratingOTP, setIsGeneratingOTP] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [isLoginDisabled, setIsLoginDisabled] = useState(true);

  const navigate = useNavigate();

  const baseUrl = process.env.REACT_APP_SERVER_BASE_URL;

  console.log(baseUrl, 'new1');

  useEffect(() => {
    setIsLoginDisabled(true); // Disable login button on page load or refresh
  }, []);

  const generateOTP = async () => {
    console.log('otp generate');

    setError("");
    setIsGeneratingOTP(true);

    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (userInput === "" || !emailRegex.test(userInput)) {
      setError("Please enter a valid email address");
      setIsGeneratingOTP(false);
      return;
    }

    try {
      // Make API call to backend to generate OTP
      let requestBody = {
        email: userInput,
      }

      const encryptedRequestBody = {
        encryptedRequestBody: encrypt(JSON.stringify(requestBody))
      };

      const response = await axios.post(`${baseUrl}/login/sendOTP`, encryptedRequestBody);
      console.log(response, 'response api');

      if (response.data.Success === true) {
        setOTPSent(true);
        toast.success(`OTP sent successfully! Please check your email.`);
        setError("");
        setIsLoginDisabled(false); // Enable login button on successful OTP generation
      } else {
        console.log("OTP generation failed:", response.data.Message);
        // ✅ CORRECTED: Use response.data.Message
        setError(response.data.Message || "Failed to generate OTP");
        toast.error(response.data.Message || "Failed to generate OTP");
      }
    } catch (error) {
      console.error("Error generating OTP:", error);
      if (error.response && error.response.data) {
        // ✅ CORRECTED: Check for Message first
        const errorMessage = error.response.data.Message || error.response.data.error || "Failed to generate OTP. Please try again.";
        setError(errorMessage);
        toast.error(errorMessage);
      } else {
        setError("Failed to generate OTP. Please try again.");
        toast.error("Failed to generate OTP. Please try again.");
      }
    } finally {
      setIsGeneratingOTP(false);
    }
  };

  const handleLogin = async () => {
    setError("");
    setIsLoggingIn(true);

    if (userInput === "") {
      setError("Please enter a valid email address");
      toast.error("Enter a valid email address");
      setIsLoggingIn(false);
      return;
    }

    if (otp === "") {
      setError("Please enter a valid OTP");
      toast.error("Enter a valid OTP");
      setIsLoggingIn(false);
      return;
    }

    try {
      let requestBody = {
        email: userInput,
        otp_code: otp,
      }

      const encryptedRequestBody = {
        encryptedRequestBody: encrypt(JSON.stringify(requestBody))
      };

      const response = await axios.post(`${baseUrl}/login/validateOTP`, encryptedRequestBody);
      console.log('res', response);

      if (response.data.Success) {
        setError("");
        toast.success("Login successful!");

        let decryptedResponse = JSON.parse(decrypt(response.data.Data));
        const res = decryptedResponse[0];

        localStorage.setItem('is_logged_in', true);
        localStorage.setItem('user_details', JSON.stringify(res.user_details));
        localStorage.setItem('ui_details', JSON.stringify(res.ui_details));

        navigate("/dashboard", {
          state: {
            userId: res.user_details.id,
            userName: res.user_details.username,
          },
        });
      } else {
        // ✅ CORRECTED: Use response.data.Message
        setError(response.data.Message || "Invalid OTP. Please try again.");
        toast.error(response.data.Message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error validating OTP:", error);
      if (error.response && error.response.data) {
        // ✅ CORRECTED: Check for Message first
        const errorMessage = error.response.data.Message || error.response.data.error || "Failed to validate OTP. Please try again.";
        setError(errorMessage);
        toast.error(errorMessage);
      } else {
        setError("Failed to validate OTP. Please try again.");
        toast.error("Failed to validate OTP. Please try again.");
      }
    } finally {
      setIsLoggingIn(false);
    }
  };

  const handleUserChange = (e) => {
    setUserInput(e.target.value);
    setError("");
  };

  const handleOtpChange = (e) => {
    setOTP(e.target.value);
    setError("");
  };

  return (
    <div className="login-container">
      {/* Left Panel - Information & Illustration */}
      <div className="login-left">
        <div className="login-left-content">
          <h1>Modern Solutions,<br />Ethical Finance.</h1>
          <p>
            Seamless Access, Everywhere You Are: Mobile, Desktop, and Detailed PDF Insights at Your Fingertips
          </p>
        </div>
        <img
          src="/login_new_image.png"
          alt="Neo Platform Preview"
          className="login-illustration"
        />
      </div>

      {/* Right Panel - Login Form */}
      <div className="login-right">
        <div className="login-form-card">
          <div className="login-logo-circle">
            <img src={logo} alt="Neo Logo" />
          </div>
          <p className="login-welcome-text">Welcome to Neo</p>

          <form onSubmit={(e) => e.preventDefault()}>
            <div className="login-input-group">
              <label htmlFor="email">
                Enter your
                <strong>Email ID</strong>
              </label>
              <input
                type="email"
                id="email"
                placeholder="Enter Email ID"
                className="login-input-field"
                value={userInput}
                onChange={handleUserChange}
              />
            </div>

            {otpSent && (
              <div className="login-input-group">
                <label htmlFor="otp">
                  Enter your
                  <strong>OTP</strong>
                </label>
                <input
                  type="text"
                  id="otp"
                  placeholder="Enter OTP"
                  className="login-input-field"
                  value={otp}
                  onChange={handleOtpChange}
                />
              </div>
            )}

            <p className="login-terms-text">
              By proceeding you agree to our <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a>
            </p>

            {!otpSent ? (
              <button
                type="button"
                className="premium-login-btn"
                onClick={generateOTP}
                disabled={isGeneratingOTP}
              >
                {isGeneratingOTP ? "Generating..." : "Generate OTP"}
              </button>
            ) : (
              <button
                type="button"
                className="premium-login-btn"
                onClick={handleLogin}
                disabled={isLoggingIn || isLoginDisabled}
              >
                {isLoggingIn ? "Logging in..." : "Login"}
              </button>
            )}

            <div className="error-message" style={{ marginTop: '15px' }}>{error ? error : ""}</div>
          </form>

          <div className="login-footer-security">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
            </svg>
            <span>Your data is <strong>SECURE</strong></span>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={3000} />
    </div>
  );
};

export default LoginPage;